export const agrupamientoLabel = (item) =>
  item.agrupamiento ? `Documento ${item.agrupamiento}` : "—";

export const estadoEsActivo = (activo) => activo === true || activo === 1;

const normalizar = (texto) =>
  texto != null ? String(texto).toLowerCase().trim() : "";

const dedupAsignacionesPorId = (asignaciones) => {
  if (!Array.isArray(asignaciones)) return [];
  const ids = new Set();
  return asignaciones.filter((asig) => {
    // Sin id no se puede deduplicar: se conserva tal cual
    if (asig?.id == null) return true;
    if (ids.has(asig.id)) return false;
    ids.add(asig.id);
    return true;
  });
};

// Colapsa entradas repetidas de la misma combinación (cliente, empresa).
// El backend puede emitir la combinación en más de un objeto; se conservan
// los campos del primero y se fusionan las asignaciones por su id (idempotente
// si son duplicados exactos). El console.warn deja evidencia de qué envió el
// backend para rastrear la causa raíz.
export const dedupClientesPorCombinacion = (clientes) => {
  if (!Array.isArray(clientes)) return [];
  const claveDe = (cliente) =>
    `${cliente?.id ?? ""}#${cliente?.idEmpresa ?? cliente?.empresa ?? ""}`;
  const indice = new Map();
  const resultado = [];
  clientes.forEach((cliente) => {
    const clave = claveDe(cliente);
    const previo = indice.get(clave);
    if (!previo) {
      const copia = {
        ...cliente,
        asignaciones: dedupAsignacionesPorId(cliente.asignaciones),
      };
      indice.set(clave, copia);
      resultado.push(copia);
      return;
    }
    console.warn(
      "[Agrupación] combinación (cliente, empresa) repetida en el response; se fusionan las asignaciones:",
      clave,
      { previo, repetido: cliente }
    );
    dedupAsignacionesPorId(cliente.asignaciones).forEach((asig) => {
      if (!previo.asignaciones.some((a) => a?.id === asig.id)) {
        previo.asignaciones.push(asig);
      }
    });
  });
  return resultado;
};

// Buscador por alias (cliente) o producto (descripcion / codigo_producto del
// item). Poda el arbol: el cliente queda solo con las asignaciones/items que
// coinciden; sin matches se oculta. Texto vacio devuelve el listado completo.
export const podarClientesPorBusqueda = (clientes, texto) => {
  if (!Array.isArray(clientes)) return [];
  const busqueda = normalizar(texto);
  if (!busqueda) return clientes;
  return clientes
    .map((cliente) => {
      if (normalizar(cliente.alias).includes(busqueda)) {
        return cliente;
      }
      const asignaciones = (Array.isArray(cliente.asignaciones)
        ? cliente.asignaciones
        : []
      )
        .map((asignacion) => {
          const detalles = (
            Array.isArray(asignacion.detalles) ? asignacion.detalles : []
          ).filter(
            (item) =>
              normalizar(item.descripcion).includes(busqueda) ||
              normalizar(item.codigo_producto).includes(busqueda)
          );
          return detalles.length > 0 ? { ...asignacion, detalles } : null;
        })
        .filter(Boolean);
      return asignaciones.length > 0 ? { ...cliente, asignaciones } : null;
    })
    .filter(Boolean);
};